import React from "react";

var HardhatIcon = function HardhatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23 20H1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1zm0-5c0-2.919-1.144-5.563-3-7.531V10c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.063.025-.118.036-.177A10.949 10.949 0 0 0 16 4.765V8c0 .55-.45 1-1 1s-1-.45-1-1V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5c0 .55-.45 1-1 1s-1-.45-1-1V4.765c-.72.281-1.399.639-2.036 1.058.011.059.036.114.036.177v4c0 .55-.45 1-1 1s-1-.45-1-1V7.469A10.937 10.937 0 0 0 1 15v3h22z"
  }));
};

HardhatIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
HardhatIcon.defaultProps.solid = true;
export default HardhatIcon;